import { Observable } from '../../Observable';
import { bufferCount } from '../../operator/bufferCount';
Observable.prototype.bufferCount = bufferCount;
//# sourceMappingURL=bufferCount.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs-es/add/operator/bufferCount.js
// module id = 149
// module chunks = 4